import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotHighwayCamerasApiMeta } from "../apiMeta";
import {
  type HighwayCamerasInput,
  highwayCamerasInputSchema,
} from "./shared/cameras.input";
import { type Camera, cameraSchema } from "./shared/cameras.output";

/**
 * Metadata for the fetchHighwayCameras endpoint
 */
export const highwayCamerasMeta = {
  functionName: "fetchHighwayCameras",
  endpoint: "/getCamerasAsJson",
  inputSchema: highwayCamerasInputSchema,
  outputSchema: cameraSchema.array(),
  sampleParams: {},
  endpointDescription: "List all highway cameras statewide.",
} satisfies EndpointMeta<HighwayCamerasInput, Camera[]>;

const { fetch, useHook } = createFetchAndHook<HighwayCamerasInput, Camera[]>({
  api: wsdotHighwayCamerasApiMeta,
  endpoint: highwayCamerasMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/cameras.endpoints").camerasGroup.cacheStrategy,
});

/**
 * Fetch function for retrieving all highway cameras statewide
 */
export const fetchHighwayCameras: FetchFactory<HighwayCamerasInput, Camera[]> =
  fetch;

/**
 * React Query hook for retrieving all highway cameras statewide
 */
export const useHighwayCameras: HookFactory<HighwayCamerasInput, Camera[]> =
  useHook;
